import React, { lazy, Suspense } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import ThemeSuspense from './components/theme/ThemeSuspense';

const Layout = lazy(() => import('./layout/Layout'));
const Login = lazy(() => import('./pages/Login'));
const SignUp = lazy(() => import('./pages/SignUp'));
const ForgotPassword = lazy(() => import('./pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./pages/ResetPassword'));

function App() {
  const { isLoggedIn } = useSelector((s) => s.auth);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="dark"
      />
      <Router>
        <Suspense fallback={<ThemeSuspense />}>
          <Routes>
            <Route
              path="/login"
              element={isLoggedIn ? <Navigate to="/" replace /> : <Login />}
            />
            <Route
              path="/signup/:refcode?"
              element={isLoggedIn ? <Navigate to="/" replace /> : <SignUp />}
            />
            <Route
              path="/forget-password"
              element={
                isLoggedIn ? <Navigate to="/" replace /> : <ForgotPassword />
              }
            />
            <Route
              path="/reset-password/:token"
              element={
                isLoggedIn ? <Navigate to="/" replace /> : <ResetPassword />
              }
            />
            <Route
              path="/*"
              element={
                isLoggedIn ? <Layout /> : <Navigate to="/login" replace />
              }
            />
          </Routes>
        </Suspense>
      </Router>
    </>
  );
}

export default App;
